<template>
    <el-dropdown trigger="click" @command="changeLanguage">
      <div>
		  <!-- <button @click="language">切换</button> -->
		  <i class="el-icon-thumb" icon-class="language">{{ $t('navbar.switch') }}</i>
        <!-- <svg-icon class-name="international-icon" icon-class="language" /> -->
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="zh" :disabled="'zh'=== $i18n.locale ">中文</el-dropdown-item>
        <el-dropdown-item command="en" :disabled="'en'=== $i18n.locale ">English</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </template>
  
  <script>
  export default {
    computed: {
    language() {
      return this.$store.getters.language
    }
  },
    methods: {
      changeLanguage(lang) {
        this.$i18n.locale = lang // 设置给本地的i18n插件
        // this.$store.dispatch('app/setLanguage', lang)
        
		// console.log('当前切换的语言版本：',this.$i18n.locale)
		this.$cookie.set('version', this.$i18n.locale)
		if(this.$i18n.locale=='zh'){
			this.$message.success('切换多语言成功')
			this.$cookie.set('language', 'zh')
		}else{
			this.$message.success('Successfully switched to multiple languages')
			this.$cookie.set('language', 'en')
		}
		
      }
    }
  }
  </script>


// WEBPACK FOOTER //
// src/components/Lang/index.vue